import React from 'react'

import { Container, Typography } from '@toptal/picasso'
import CountUp from 'react-countup'

import { connect } from 'react-redux'
import { IStoreState } from '../../utils'

interface IProps {
  prevValue?: number
  value?: number
  merged?: boolean
}

const ANIMATION_SECS = 1

export const Combinations: React.FunctionComponent<IProps> = ({
  value = 0,
  prevValue = 0,
  merged = false
}) => {
  const combinations = value === 1 ? 'combination' : 'combinations'
  const action = merged ? 'merged!' : 'possible'
  const suffix = ` ${combinations} ${action}`

  return (
    <Container top='small' bottom='medium'>
      <Typography
        align='center'
        variant='large'
        style={{ fontSize: '1.75rem' }}
      >
        <CountUp
          start={prevValue}
          end={value}
          duration={ANIMATION_SECS}
          separator=','
        />
        {suffix}
      </Typography>
    </Container>
  )
}

const mapStateToProps = (state: IStoreState) => ({
  value: state.combinations,
  prevValue: state.prevCombinations,
  merged: state.merged
})

const CombinationsSmart = connect(mapStateToProps)(Combinations)

export default CombinationsSmart
